<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <Navigation v-if="!isAuthPage" />
    
    <main :class="isAuthPage ? '' : 'pt-16'">
      <router-view />
    </main>
    
    <Footer v-if="!isAuthPage" />
    
    <!-- Loading overlay -->
    <div v-if="loading" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white rounded-lg p-6 flex items-center space-x-3">
        <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-primary-600"></div>
        <span>Chargement...</span>
      </div>
    </div>
    
    <!-- Notification -->
    <Notification 
      v-if="notification.show" 
      :type="notification.type"
      :message="notification.message"
      @close="clearNotification"
    />
    
    <!-- Content Debug Component (Development only) -->
    <ContentDebug v-if="isDevelopment" />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useAppStore } from '@/stores/app'
import { useAuthStore } from '@/stores/auth'
import Navigation from '@/components/Navigation.vue'
import Footer from '@/components/Footer.vue'
import Notification from '@/components/Notification.vue'
import ContentDebug from '@/components/ContentDebug.vue'

const route = useRoute()
const appStore = useAppStore()
const authStore = useAuthStore()

const loading = computed(() => appStore.loading)
const notification = computed(() => appStore.notification)

const isAuthPage = computed(() => 
  route.name === 'login' || route.name === 'register' || route.name === 'forgot-password'
)

const isDevelopment = computed(() => 
  import.meta.env.DEV || import.meta.env.VITE_SHOW_DEBUG === 'true'
)

const clearNotification = () => {
  appStore.clearNotification()
}

onMounted(() => {
  // Initialize auth state
  authStore.checkAuthStatus()
})
</script>